
const API = {
    //template
    GET_LIST_TEMPLATE: '/admin/template',
    GET_DETAIL_TEMPLATE: '/admin/template',
    SAVE_TEMPLATE: '/admin/template',
    DELETE_TEMPLATE: '/admin/template',
    UPDATE_TEMPLATE: '/admin/template',
    GET_LIST_TEMPLATE_BY_SEARCH: '/admin/search/template',
    GET_TEMPLATE_BY_COPY: '/admin/copy/template',
    //template size
    GET_LIST_TEMPLATE_SIZE: '/admin/template-size',
    GET_DETAIL_TEMPLATE_SIZE: '/admin/template-size',
    SAVE_TEMPLATE_SIZE: '/admin/template-size',
    DELETE_TEMPLATE_SIZE: '/admin/template-size',
    UPDATE_TEMPLATE_SIZE: '/admin/template-size',
    //template type
    GET_LIST_TEMPLATE_TYPE: '/admin/template-type',
    GET_DETAIL_TEMPLATE_TYPE: '/admin/template-type',
    SAVE_TEMPLATE_TYPE: '/admin/template-type',
    DELETE_TEMPLATE_TYPE: '/admin/template-type',
    UPDATE_TEMPLATE_TYPE: '/admin/template-type',
    /*template theme*/
    GET_LIST_TEMPLATE_THEMES: '/admin/template-category',
    SAVE_TEMPLATE_THEMES: '/admin/template-category',
    DELETE_TEMPLATE_THEMES: '/admin/template-category',
    GET_DETAIL_TEMPLATE_THEMES: '/admin/template-category',
    UPDATE_TEMPLATE_THEMES: '/admin/template-category',
    //order
    GET_LIST_ORDER: '/admin/order',
    GET_DETAIL_ORDER: '/admin/order',
    DELETE_ORDER: '/admin/order',
    GET_LIST_ORDER_BY_SEARCH: 'admin/search/order',
    UPLOAD_IMAGE_DESIGN: '/admin/upload/design',
    UPLOAD_ORDER: '/admin/order',

    /*payment*/
    GET_LIST_PAYMENTS: '/admin/transaction',
    GET_DETAIL_PAYMENTS: '/admin/transaction',
    GET_LIST_PAYMENTS_BY_SEARCH: '/admin/search/transaction',
    /*user*/
    GET_LIST_USERS: '/admin/user',
    GET_DETAIL_USER: '/admin/user',
    UPDATE_USERS: '/admin/user',
    GET_LIST_USERS_BY_SEARCH: '/admin/search/user',
    /*tags*/
    GET_LIST_TAGS: '/admin/tag',
    SAVE_TAGS: '/admin/tag',
    DELETE_TAGS: '/admin/tag',
    GET_DETAIL_TAGS: '/admin/tag',
    UPDATE_TAGS: '/admin/tag',

    /*bundle*/
    GET_LIST_BUNDLE: '/admin/bundle',
    GET_DETAIL_BUNDLE: '/admin/bundle',
    SAVE_BUNDLE: '/admin/bundle',
    UPDATE_BUNDLE: '/admin/bundle',
    DELETE_BUNDLE: '/admin/bundle',
    GET_LIST_BUNDLE_BY_SEARCH: '/admin/search/bundle',

    /* fonts*/
    UPLOAD_FONT_BY_TEMPLATE : '/api/upload/font',
    GET_ALL_FONT : '/api/fonts',

    // Custom design
    GET_LIST_TEMPLATE_TEMPLATE_SIZE: '/admin/list-template-template-sizes',
    SAVE_CUSTOM_DESIGN: '/admin/save-custom-design',
    GET_CUSTOM_DESIGN: '/admin/get-custom-design'
}
export default API
